// Third party manager that handles loading based on storage policy categories
const HThirdPartyManager = {
    _queues: {
        [HStoragePolicyManager.Categories.NECESSARY]: [],
        [HStoragePolicyManager.Categories.PREFERENCES]: [],
        [HStoragePolicyManager.Categories.ANALYTICS]: [],
        [HStoragePolicyManager.Categories.MARKETING]: [],
    },

    register(category, fn, customId = null) {
        return new Promise((resolve, reject) => {
        if (!this._queues[category]) {
            console.error(`Invalid category: ${category}`);
            resolve(null);
        }

        if (typeof fn !== 'function') {
            console.error('Second parameter must be a function');
            resolve(null);
        }

        const id = customId || `${category}_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

        // Check if custom ID already exists
        if (customId && this._queues[category].some(item => item.id === customId)) {
            console.warn(`Registration with ID ${customId} already exists. Skipping.`);
            resolve(id);
        }

        this._queues[category].push({
            id,
            fn,
            executed: false
        });

        // If category is already allowed, execute immediately
        if (HStoragePolicyManager.isCategoryEnabled(category)) {
            resolve(this._execute(fn));
        } else {
            resolve(id);
        }
        });
    },

    unregister(category, id) {
        if (!this._queues[category]) {
            console.error(`Invalid category: ${category}`);
            return;
        }

        const index = this._queues[category].findIndex(item => item.id === id);
        if (index !== -1) {
            this._queues[category].splice(index, 1);
        }
    },

    onCookiesPolicyChanged() {
        // Check each category and execute pending functions for enabled ones
        Object.keys(this._queues).forEach(category => {
            if (HStoragePolicyManager.isCategoryEnabled(category)) {
                this.loadCategory(category);
            }
        });
    },

    loadCategory(category) {
        if (!this._queues[category]) {
            console.error(`Invalid category: ${category}`);
            return;
        }

        this._queues[category].forEach(item => {
            if (!item.executed) {
                this._execute(item.fn);
                item.executed = true;
            }
        });
    },

    _execute(fn) {
        try {
            fn();
        } catch (error) {
            console.error('Error executing function:', error);
        }
    }
};

if (typeof window !== "undefined") {
    window.HThirdPartyManager = HThirdPartyManager;
} 